import * as React from 'react';

import {Button} from 'shells/button/button';
import {CheckboxForGroup} from 'shells/checkbox/checkbox-for-group';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

// @ts-expect-error
import {ALL_AUDIENCES} from './consts';
import type {Audience} from './types';

import styles from './preference-center.module.css';

type Props = {
    publicAudiences: Audience[];
    currentAudience?: Audience;
    unsubscribeUrl?: string;
    preferencesUrl?: string;
    onSuccessfulUnsubscribe: () => void;
};

export function PreferenceCenter(props: Props) {
    const [selectedAudiences, setSelectedAudiences] = React.useState<string[]>(
        getInitialSelectedAudiences(props.currentAudience, props.publicAudiences)
    );

    return (
        <>
            <div className='mt-32'>
                <Body color='dark' isBold={true} size='large'>
                    What type of communication would you like to receive?
                </Body>
            </div>
            <StackLegacy spacing={16}>
                <CheckboxGroup
                    name='preference-group'
                    selectedValues={selectedAudiences}
                    onChange={setSelectedAudiences}
                >
                    <div className={styles['preference-options-container']}>
                        {props.publicAudiences.map((audience) => (
                            <CheckboxForGroup key={audience.id} value={audience.id} isLarge={false}>
                                <div className={styles['preference-option']}>
                                    <Body color='dark' isBold={true}>
                                        {audience.name}
                                    </Body>
                                    <Body color='dark'>{audience.description}</Body>
                                </div>
                            </CheckboxForGroup>
                        ))}
                    </div>
                </CheckboxGroup>
                <Button
                    size='xlarge'
                    variant='primary'
                    isFullWidth={true}
                    onClick={() => {
                        if (props.preferencesUrl) {
                            Nut.ajax.post({
                                url: props.preferencesUrl,
                                data: {audienceIds: selectedAudiences},
                                success: props.onSuccessfulUnsubscribe,
                            });
                        }
                    }}
                >
                    Save
                </Button>
                <div className='flex align-center justify-center'>
                    <hr className={styles.divider} />
                    <Body color='light'>or</Body>
                    <hr className={styles.divider} />
                </div>
                <Button
                    size='xlarge'
                    variant='upgrade'
                    isFullWidth={true}
                    onClick={() => {
                        if (props.unsubscribeUrl) {
                            Nut.ajax.post({
                                url: props.unsubscribeUrl,
                                data: {type: ALL_AUDIENCES},
                                success: props.onSuccessfulUnsubscribe,
                            });
                        }
                    }}
                >
                    Unsubscribe from all emails
                </Button>
            </StackLegacy>
        </>
    );
}

function getInitialSelectedAudiences(
    currentAudience: Audience | null | undefined,
    publicAudiences: Audience[]
): string[] {
    const selectedAudiences = [];
    if (currentAudience && currentAudience.isSubscribed) {
        selectedAudiences.push(currentAudience.id);
    }

    for (const audience of publicAudiences) {
        if (audience.isSubscribed) {
            selectedAudiences.push(audience.id);
        }
    }

    return selectedAudiences;
}
